<template>
  <div id="app">
    <div class="body_bg">
      <div class="container pd15 whitebg">
        <el-row :gutter="25">
            <div class="grid-content bg-purple-light">
              <div class="side_con">
                <div class="title_all" style=" margin-bottom: 0;">
                  <div class="title_left">{{title}}</div>
                  <div class="title_more2"><a href="">首页</a>>{{title}}</div>
                  <div class="clearfix"></div>
                </div>
                <div class="side_container">
                  <div class="xbjj_con ">
                    <div class="pic_link">
                      <el-row :gutter="25" class="row ten">
                        <el-col class="linkpic text-center" v-for="(item,index) in linkpic" :key="index" :xs="24" :sm="24" :md="12" :lg="8" :xl="8"><a :href="item.Url"><img :src="Url+item.PictureGUID" style="width:220px;height:60px;"></a></el-col>
                        <div class="clearfix"></div>
                      </el-row>
                    </div>
                  </div>
                </div>
              </div>
            </div>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        linkpic:[],
        id:0,
        title:""
      }
    },
    components: {
    },
   async mounted(){
       if(this.$route.query.id){
           if(this.$route.query.id=='2'){
               this.title="理事单位"
               document.title="理事单位"
           }else{
               this.title="专题栏目"
               document.title="专题栏目"
           }
           let linkpic = await this.$store.dispatch("_getBannerList", { ID:this.$route.query.id });
    this.linkpic = linkpic.data.Data;
       }
    
    },
    methods: {
    
    }
  }
</script>

<style scoped>

</style>
